import { ArrayParam, StringParam, ObjectParam, JsonParam } from 'use-query-params'

import { dateFormat } from '@app/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { INTERNAL_TASKS_STATUS } from '@app/constants/internalTasksStatus'
import { TASK_TYPE } from '@app/constants/taskType'

import type { InternalTasksDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTitleSchema } from '@app/types/table'

export const columnTitleSchema: ColumnTitleSchema<InternalTasksDataSource> = {
  name: 'Наименование',
  monitoringId: 'Ссылка',
  taskType: 'Тип задачи',
  deadline: 'Срок исполнения',
  executor: 'Исполнитель',
  role: 'Роль',
  status: 'Статус',
  initiator: 'Инициатор',
  salesOrganization: 'Сбытовая организация',
  monitoringType: 'Тип мониторинга',
  cluster: 'Кластер'
} as const

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.executor]: StringParam,
  [FILTERS_PARAMS_KEYS.taskTypes]: ArrayParam,
  [FILTERS_PARAMS_KEYS.createdAtFrom]: StringParam,
  [FILTERS_PARAMS_KEYS.createdAtTo]: StringParam,
  [FILTERS_PARAMS_KEYS.deadlineFrom]: StringParam,
  [FILTERS_PARAMS_KEYS.deadlineTo]: StringParam,
  [FILTERS_PARAMS_KEYS.statuses]: ArrayParam,
  [FILTERS_PARAMS_KEYS.executorUserIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam
} as const

export const tableSearchQuerySchema: TableSearchQuerySchema<InternalTasksDataSource> = {
  'table-name': StringParam,
  'table-taskType': StringParam,
  'table-deadline': ObjectParam,
  'table-executor': StringParam,
  'table-role': StringParam,
  'table-status': JsonParam,
  'table-initiator': StringParam,
  'table-salesOrganization': StringParam,
  'table-monitoringType': StringParam,
  'table-cluster': StringParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const titleWrapperDateProps = { minWidth: 215 } as const

const optionsStatus = [
  { label: 'согласование', value: INTERNAL_TASKS_STATUS.APPROVAL },
  { label: 'согласование ДУК', value: INTERNAL_TASKS_STATUS.DKC_APPROVAL },
  { label: 'согласование СОАЦ', value: INTERNAL_TASKS_STATUS.SOAC_APPROVAL },
  { label: 'на доработке', value: INTERNAL_TASKS_STATUS.UNDER_REVISION },
  { label: 'согласована', value: INTERNAL_TASKS_STATUS.APPROVED },
  { label: 'согласована с изменениями', value: INTERNAL_TASKS_STATUS.APPROVED_WITH_CHANGES },
  { label: 'согласована частично', value: INTERNAL_TASKS_STATUS.PARTIALLY_APPROVED },
  { label: 'просрочена', value: INTERNAL_TASKS_STATUS.OVERDUE },
  { label: 'отклонена', value: INTERNAL_TASKS_STATUS.REJECTED },
  { label: 'отменена инициатором', value: INTERNAL_TASKS_STATUS.CANCELLED_BY_INITIATOR }
]
const optionsTaskType = [
  { label: 'рекомендации к изменению', value: TASK_TYPE.RECOMMENDATION_MODIFICATION },
  { label: 'рекомендации к удалению', value: TASK_TYPE.RECOMMENDATION_REMOVAL }
]

export const columnsSearchSchema: ColumnTableSearchSchema<InternalTasksDataSource> = {
  name: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  taskType: {
    type: columnSearchSchemaOptionType.SELECT,
    titleWrapperProps,
    controlProps: { options: optionsTaskType }
  },
  deadline: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  executor: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  role: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  status: { type: columnSearchSchemaOptionType.SELECT, titleWrapperProps, controlProps: { options: optionsStatus } },
  initiator: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  salesOrganization: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps }
}
